import { useAtom } from 'jotai';

import { type GradeTab, gradeTabAtom } from '../store/atoms/gradeConfigAtom';

/**
 * Hook da aba ativa (Configuração × Resumo & simulador), encapsulando o átomo.
 *
 * @returns `{ tab, isConfig, setTab }`
 */
export function useGradeConfigTabs() {
  const [tab, setTab] = useAtom(gradeTabAtom);
  return { tab, isConfig: tab === 'config', setTab: (next: GradeTab) => setTab(next) } as const;
}
